import React from "react";
import './footer.css'

function Footer() {
  return (
    <div>
      <footer>
        <span>
          Created By Group<a> 2 </a> | <span class="far fa-copyright"></span> 2021
          All rights reserved.
        </span>
      </footer>
    </div>
  );
}

export default Footer;
